// extracted by mini-css-extract-plugin
export default {"whiteColor":"Font_whiteColor__0weu+","errorColor":"Font_errorColor__lRAeW"};